module.exports=["react","solid"];